import React from 'react';
import Cookies from 'js-cookie';

const CookiesContext = React.createContext(Cookies);

export default CookiesContext;
